import resolveError from './errorResolver'
/* eslint-disable */
const mergeMessages = (title, detail) => (detail ? `${title}\n${detail}` : title)

export default {
  install(Vue) {
    const resolveAndCache = error => {
      if (error && error._resolved) return error._resolved
      const resolved = resolveError(error)
      if (error) {
        // cache resolved error on the original object to avoid re-processing
        error._resolved = resolved
      }
      return resolved
    }

    Vue.prototype.$resolveError = function $resolveError(error) {
      return resolveAndCache(error)
    }

    Vue.prototype.$handleError = function $handleError(error) {
      const resolved = resolveAndCache(error)
      const { title, detail } = resolved
      const message = mergeMessages(title, detail)

      if (this && typeof this.$erro === 'function') {
        this.$erro(message)
        return resolved
      }

      if (this && typeof this.$swal === 'function') {
        this.$swal({
          icon: 'error',
          title,
          text: detail || undefined,
        })
        return resolved
      }

      const toast = (this && this.$toast) || Vue.prototype.$toast
      if (toast) {
        if (typeof toast.error === 'function') {
          toast.error(message)
        } else if (typeof toast === 'function') {
          toast(message)
        }
        return resolved
      }

      // eslint-disable-next-line no-console
      console.error(message)
      return resolved
    }
  },
}
